export default "__VITE_ASSET__COx3_5if__"